import { isPossiblePhoneNumber } from 'libphonenumber-js';
import { isEmpty, isUndefined } from 'lodash';

import { TXTWCL_Invalid_phone_number, TXTWCL_Please_enter_phone_number } from '../translations';
import type { Error } from '../types';

export const phoneRMF =
  (code: string | undefined, required = true) =>
  (value: string): Error => {
    const phoneNumber = '+' + code + value;
    const isValidNumber = isPossiblePhoneNumber(phoneNumber);

    if (isUndefined(value) || isEmpty(value)) {
      if (!required) return { valid: true };
      return {
        valid: false,
        message: TXTWCL_Please_enter_phone_number
      };
    }

    if (value && !isValidNumber) {
      return {
        valid: false,
        message: TXTWCL_Invalid_phone_number
      };
    }

    return {
      valid: true
    };
  };
